import { render } from "./Start.vue?vue&type=template&id=528dd4fa&scoped=true&ts=true"
import script from "./Start.vue?vue&type=script&lang=ts"
export * from "./Start.vue?vue&type=script&lang=ts"

import "./Start.vue?vue&type=style&index=0&id=528dd4fa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/on-the-edge-client/on-the-edge-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528dd4fa"]])

export default __exports__